export const prospectOutreachModal = {
    type: 'prospect',
    id: 0,
    attributes: {
        lastName: '',
        firstName: '',
        mobilePhones: [],
        workPhones: [],
        emails: [],
        linkedInUrl: '',
        title: '',
        addressStreet: '',
        addressCity: '',
        addressZip: '',
        addressState: '',
        addressCountry: '',
        custom1: '',
        custom2: '',
        custom3: '',
        custom4: '',
        custom5: '',
        custom6: '',
        custom7: '',
        custom8: '',
        custom9: '',
        custom10: '',
        custom11: '',
        custom12: '',
        custom13: '',
        custom14: '',
        custom15: '',
        custom16: '',
        custom17: '',
        custom18: '',
        custom19: '',
        custom20: ''
    }
};

export const accountOutreachModal = {
    type: 'account',
    id: 0,
    attributes: {
        name: '',
        domain: '',
        industry: '',
        numberOfEmployees: '',
        custom1: '',
        custom2: '',
        custom3: '',
        custom4: '',
        custom5: '',
        custom6: '',
        custom7: '',
        custom8: '',
        custom9: '',
        custom10: '',
        custom11: '',
        custom12: '',
        custom13: '',
        custom14: '',
        custom15: '',
        custom16: '',
        custom17: '',
        custom18: '',
        custom19: '',
        custom20: ''
    }
};
